import { render, staticRenderFns } from "./Aimodel.vue?vue&type=template&id=188fc506&"
import script from "./Aimodel.vue?vue&type=script&lang=js&"
export * from "./Aimodel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports